/* tslint:disable */
/* eslint-disable */
/**
 * P4m.Module.Auth.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AuthClaimReadDto,
    AuthClaimReadDtoFromJSON,
    AuthClaimReadDtoToJSON,
} from '../models/AuthClaimReadDto';
import {
    type GetUserInformationDto,
    GetUserInformationDtoFromJSON,
    GetUserInformationDtoToJSON,
} from '../models/GetUserInformationDto';
import {
    type LoginDto,
    LoginDtoFromJSON,
    LoginDtoToJSON,
} from '../models/LoginDto';
import {
    type UserWithClaimsDto,
    UserWithClaimsDtoFromJSON,
    UserWithClaimsDtoToJSON,
} from '../models/UserWithClaimsDto';

export interface UiApiAuthLoginPostRequest {
    loginDto: LoginDto;
}

export interface UiApiAuthLogoutGetRequest {
    logoutId?: string;
}

export interface UiApiAuthUserInfoPostRequest {
    getUserInformationDto: GetUserInformationDto;
}

/**
 * 
 */
export class UiApiAuthApi extends runtime.BaseAPI {

    /**
     * Creates request options for uiApiAuthLoginPost without sending the request
     */
    async uiApiAuthLoginPostRequestOpts(requestParameters: UiApiAuthLoginPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['loginDto'] == null) {
            throw new runtime.RequiredError(
                'loginDto',
                'Required parameter "loginDto" was null or undefined when calling uiApiAuthLoginPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/ui-api/auth/login`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LoginDtoToJSON(requestParameters['loginDto']),
        };
    }

    /**
     * Вход пользователя в модуль
     */
    async uiApiAuthLoginPostRaw(requestParameters: UiApiAuthLoginPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.uiApiAuthLoginPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Вход пользователя в модуль
     */
    async uiApiAuthLoginPost(requestParameters: UiApiAuthLoginPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.uiApiAuthLoginPostRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for uiApiAuthLogoutGet without sending the request
     */
    async uiApiAuthLogoutGetRequestOpts(requestParameters: UiApiAuthLogoutGetRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['logoutId'] != null) {
            queryParameters['logoutId'] = requestParameters['logoutId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/ui-api/auth/logout`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Выполняет выход пользователя из системы.  logoutId передаётся IdentityServer при OIDC-logout через /connect/endsession (UserInteraction.LogoutUrl).
     */
    async uiApiAuthLogoutGetRaw(requestParameters: UiApiAuthLogoutGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.uiApiAuthLogoutGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Выполняет выход пользователя из системы.  logoutId передаётся IdentityServer при OIDC-logout через /connect/endsession (UserInteraction.LogoutUrl).
     */
    async uiApiAuthLogoutGet(requestParameters: UiApiAuthLogoutGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.uiApiAuthLogoutGetRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for uiApiAuthUserInfoPost without sending the request
     */
    async uiApiAuthUserInfoPostRequestOpts(requestParameters: UiApiAuthUserInfoPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['getUserInformationDto'] == null) {
            throw new runtime.RequiredError(
                'getUserInformationDto',
                'Required parameter "getUserInformationDto" was null or undefined when calling uiApiAuthUserInfoPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/ui-api/auth/user-info`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetUserInformationDtoToJSON(requestParameters['getUserInformationDto']),
        };
    }

    /**
     */
    async uiApiAuthUserInfoPostRaw(requestParameters: UiApiAuthUserInfoPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserWithClaimsDto>> {
        const requestOptions = await this.uiApiAuthUserInfoPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserWithClaimsDtoFromJSON(jsonValue));
    }

    /**
     */
    async uiApiAuthUserInfoPost(requestParameters: UiApiAuthUserInfoPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserWithClaimsDto> {
        const response = await this.uiApiAuthUserInfoPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uiApiAuthUserPermissionsGet without sending the request
     */
    async uiApiAuthUserPermissionsGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/ui-api/auth/user-permissions`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Получение списка клайм модуля авторизации текущего пользователя
     */
    async uiApiAuthUserPermissionsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AuthClaimReadDto>>> {
        const requestOptions = await this.uiApiAuthUserPermissionsGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AuthClaimReadDtoFromJSON));
    }

    /**
     * Получение списка клайм модуля авторизации текущего пользователя
     */
    async uiApiAuthUserPermissionsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AuthClaimReadDto>> {
        const response = await this.uiApiAuthUserPermissionsGetRaw(initOverrides);
        return await response.value();
    }

}
